import React, { useEffect, useState } from "react";

/**
 * Minimal page that collects non‑intrusive visitor data.
 * Replace the flushes to `console.log` with POSTs to your backend
 * if you have a lawful basis to store the data.
 */
export default function VisitorInfo() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const t0 = performance.now();

    // 1️⃣ Pull IP + rough geo (public JSON, no API‑key needed – low quota)
    fetch("https://ipapi.co/json/")
      .then((r) => r.json())
      .then((ipinfo) => {
        // 2️⃣ Client‑side details
        const clientInfo = {
          ip: ipinfo.ip,
          city: ipinfo.city,
          region: ipinfo.region,
          country: ipinfo.country_name,
          isp: ipinfo.org,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          language: navigator.language,
          userAgent: navigator.userAgent,
          referrer: document.referrer || "Direct / None",
          screen: `${window.screen.width}×${window.screen.height}`,
          viewport: `${window.innerWidth}×${window.innerHeight}`,
          colorDepth: window.screen.colorDepth,
          deviceMemory: navigator.deviceMemory || "n/a",
          hardwareConcurrency: navigator.hardwareConcurrency || "n/a",
          loadTimeMs: Number((performance.now() - t0).toFixed(0)),
          visitedAt: new Date().toISOString(),
        };

        setData(clientInfo);
        console.log("✅ Visitor data collected:", clientInfo);

        // 👉 OPTIONAL: send to your API
        // fetch("/api/collect", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(clientInfo) });
      })
      .catch((err) => console.error("IP lookup failed", err));
  }, []);

  if (!data) return <p className="text-gray-500 p-4">Gathering visitor info…</p>;

  return (
    <main className="min-h-screen bg-gray-100 text-gray-800 font-sans flex items-center justify-center">
      <div className="bg-white shadow-lg rounded-xl p-8 max-w-md w-full">
        <h1 className="text-xl font-semibold mb-4 text-center">Your Visit Snapshot</h1>

        <ul className="space-y-2 text-sm">
          {Object.entries(data).map(([k, v]) => (
            <li key={k} className="flex justify-between">
              <span className="font-medium capitalize">{k.replace(/([A-Z])/g, " $1")}</span>
              <span>{String(v)}</span>
            </li>
          ))}
        </ul>

        <p className="mt-6 text-xs text-gray-500 text-center">
          Data shown here is captured automatically on most websites. No precise
          GPS or cookies were used.
        </p>
      </div>
    </main>
  );
}
